module.exports = __webpack_public_path__ + "static/media/visa.abeec7af.png";